import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigation } from '@/context/NavigationContext';
import { resolvePortalHomeRoute } from '@/lib/account-routing';

export default function ActiveAccountPrompt() {
  const { navigate } = useNavigation();
  const target = resolvePortalHomeRoute();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>This page needs an account compatibility record</CardTitle>
          <CardDescription>
            The portal now starts from tenant context. Return to portal home and choose the next workspace from there.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button type="button" onClick={() => navigate(target)}>
            Return to portal home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
